import wishlist from "./_wishlist";
import {productblockInit} from "./productblock";

const wishlistPage = document.querySelector('.js-wishlist');

const updateWishlistTriggers = () => {
    [...document.querySelectorAll('.js-wishlist-trigger')].map(trigger => {
        if(wishlist.containsProduct(trigger.dataset.url) && !trigger.hasAttribute('data-in')) {
            trigger.setAttribute('data-state', 'loading');
            trigger.setAttribute('data-in', '');
            setTimeout(() => trigger.setAttribute('data-state', 'done'), 500);
        } else if(!wishlist.containsProduct(trigger.dataset.url) && trigger.hasAttribute('data-in')) {
            trigger.setAttribute('data-state', 'loading');
            trigger.removeAttribute('data-in');
            setTimeout(() => trigger.setAttribute('data-state', 'done'), 500);

            if(wishlistPage) {
                setTimeout(() => trigger.closest('.js-productblock').remove(), 200);
            }
        }
    });

    [...document.querySelectorAll('.js-wishlist-count')].map(countElement => {
        const count = wishlist.products.length;

        if(count === 0) {
            countElement.removeAttribute('data-count');
        } else {
            countElement.setAttribute('data-count', count);
        }
    });
};

export const wishlistTriggerInit = trigger => {
    trigger.addEventListener('click', e => {
        e.preventDefault();
        wishlist.toggleProduct(trigger.dataset.url);

        updateWishlistTriggers();

        if(wishlistPage && wishlist.products.length === 0) {
            const wishlistEmpty = wishlistPage.querySelector('.js-wishlist-empty');
            wishlistEmpty.classList.remove('d-none');
        }
    });
}

[...document.querySelectorAll('.js-wishlist-trigger')].map(wishlistTriggerInit);
updateWishlistTriggers();

if(wishlistPage) {
    const wislistGrid = wishlistPage.querySelector('.js-wishlist-grid');
    const wishlistEmpty = wishlistPage.querySelector('.js-wishlist-empty');
    const productblockTemplate = wishlistPage.querySelector('.js-productblock');

    if(wishlist.products.length > 0) {
        wishlist.products.map(async productUrl => {
            const clone = productblockTemplate.cloneNode(true);
            wislistGrid.appendChild(clone);

            await productblockInit(clone, productUrl);

            clone.classList.remove('d-none');
        });

        [...document.querySelectorAll('.js-wishlist-trigger')].map(wishlistTriggerInit);
    } else {
        wishlistEmpty.classList.remove('d-none');
    }

    productblockTemplate.remove();
    wislistGrid.firstElementChild.remove();
}
